module.exports = __webpack_public_path__ + "Roboto-Medium.woff2";